import { SET_DISCOUNT, SET_PRICING } from "../actions/types";
const initialState = {
    lineItems: [],
    banner_text: "",
    discount_str: [],
    recurring_discount_str: "",
    user_cart: [],
    referral_data: { stored: 0, loaded: false }
};
export default function pricingReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PRICING: {
            return action.payload;
        }
        case SET_DISCOUNT: {
            return {
                ...state,
                discount_str: action.payload,
            };
        }
        default:
            return state;
    }
}
